import React, { useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import UserProfile from "../UserProfile/userProfile";
import avatarPlaceholder from "../../images/avatar_icon.png";
import { fetchUserProfile } from "../../actions/userProfileActions";
import BackNavigator from "../BackNavigator/BackNavigator";
import Avatar from "@mui/material/Avatar";
import { getInitials } from "../../utils/utils";
import Typography from "@mui/material/Typography";
import useNetwork from "../UseNetwork";

// Styles moved to sx prop below

const AppHeader = ({
  children,
  employeeInfo,
  profileinfo,
  userProfileinfo,
  headerContent,
  backNaviagtorHidden,
}) => {
  // Styles moved to sx prop below
  // No more useStyles/classes
  const headerRef = useRef(0);
  const employeeId = (employeeInfo.empId || "").padStart(6, "0");
  const employeeAvatarName = employeeInfo.name || "";
  const networkStatus = useNetwork();
  const [openProfile, setOpenProfile] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleProfileClick = (e) => {
    const userData = {
      username: employeeId,
    };
    profileinfo(userData);
    setOpenProfile(true);
    if (globalThis.newrelic) {
      setTimeout(function Pagecallerfun() {
        globalThis.newrelic.addPageAction("User-Profile", { result: "success" });
      }, 1000);
    }
  };
  const closeProfile = () => {
    if (userProfileinfo?.error?.code === "ERR_UP_INVALID_ACCESS_TOKEN") {
      globalThis.location.reload();
    }

    setOpenProfile(false);
    setOpenSnackbar(false);
  };

  const OnLogoutClick = (e) => {
    e.preventDefault();
    setOpenSnackbar(false);
    if (networkStatus) {
      localStorage.clear();
      sessionStorage.clear();
      caches.keys().then(function (names) {
        for (let name of names) caches.delete(name);
      });
      globalThis.location.href = process.env.REACT_APP_PINGONE_LOGOUT_URL;
    } else {
      setOpenSnackbar(true);
    }
  };

  const appBarHeight = headerRef.current.clientHeight || 0;
  return (
    <div style={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        ref={headerRef}
        sx={{
          transition: (theme) =>
            theme.transitions.create(["margin", "width"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
        }}
      >
        <Toolbar>
          <div
            style={{
              display: "flex",
              width: "100%",
              minHeight: "10rem",
              justifyContent: "space-between",
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                paddingBottom: "1rem",
              }}
            >
              <div style={{ width: "3.5rem", height: "3.5rem" }} />
              {!backNaviagtorHidden && (
                <div style={{ width: "3.5rem", height: "3.5rem" }}>
                  <BackNavigator
                    style={{ width: "100%", height: "100%" }}
                    data-testid="back-navigator"
                  />
                </div>
              )}
            </div>

            {headerContent}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <button
                type="button"
                aria-label="Open profile"
                className="profile-icon-button"
                onClick={handleProfileClick}
                data-testid="profile-icon"
              >
                <Avatar
                  sx={{
                    color: "#353535",
                    backgroundColor: "#dfdfdf",
                    border: "1px  #353535",
                    cursor: "pointer",
                    fontWeight: "bolder",
                    fontSize: "18px",
                    '@media (max-width: 280px)': {
                      right: "10px",
                    },
                  }}
                  alt={avatarPlaceholder}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: "bolder",
                      fontSize: "18px",
                      color: "#353535",
                    }}
                  >
                    {getInitials(employeeAvatarName)}
                  </Typography>
                </Avatar>
              </button>

              <UserProfile
                open={openProfile}
                handleClose={closeProfile}
                signOut={OnLogoutClick}
                onConnectionError={openSnackbar}
                data-testid="user-profile"
              />
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <main style={{ height: "100vh", width: "100%" }}>
        <div
          style={{
            width: "100vw",
            background: "#f3f3f3",
            marginTop: `${appBarHeight}px`,
            height: `calc(100% - ${appBarHeight}px)`,
            minHeight: 0,
          }}
        >
          {children}
        </div>
      </main>
    </div>
  );
};

const mapStateToProps = (state) => ({
  employeeInfo: state.auth.employeeInfo,
  userProfileinfo: state.userprofile,
});

const mapDispatchToProps = (dispatch) => ({
  profileinfo: (userData) => dispatch(fetchUserProfile(userData)),
});

AppHeader.propTypes = {
  children: PropTypes.node,
  employeeInfo: PropTypes.shape({
    empId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }),
  profileinfo: PropTypes.func,
  userProfileinfo: PropTypes.object,
  headerContent: PropTypes.node,
  backNaviagtorHidden: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
